export const Locale = {
  EN: 'en-US',
  ES: 'es-US',
}

export type Locale = (typeof Locale)[keyof typeof Locale]

export const availableLanguages = [
  { code: Locale.EN, name: 'English' },
  { code: Locale.ES, name: 'Español' },
]
